<template>
  <generic-modal
    :title="$t('service list')"
    ref="generic_modal"
    :is_wide="true"
  >
    <table class="table is-striped is-hoverable is-fullwidth">
      <thead>
        <tr>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("description") }}</th>
          <th>{{ $t("number of hours") }}</th>
          <th>{{ $t("actions") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="service in filtered_services" :key="service.uuid">
          <td>{{ format_date(service.date) }}</td>
          <td>{{ service.description }}</td>
          <td>{{ service.number_of_hours }}</td>
          <td>
            <div
              class="button is-secondary is-rounded"
              @click="edit_service(service.uuid)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div>
            <div
              class="button is-secondary is-rounded"
              @click="delete_service(service.uuid)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="4">
            <div class="field has-addons">
              <div class="control is-expanded">
                <input
                  class="input"
                  type="text"
                  placeholder="Search services..."
                  v-model="search_query"
                />
              </div>
              <div class="control">
                <button
                  class="button is-primary is-rounded"
                  @click="datatable.search(search_query)"
                >
                  <span class="icon"><i class="fa fa-search"></i></span>
                </button>
              </div>
            </div>
          </th>
        </tr>
      </tfoot>
    </table>
    <!-- <pre>{{ service_list }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  del,
  post,
  error_alert,
  confirm_deletion_dialog,
  format_date,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "TimebagServicesModal",
  components: { GenericModal },
  data() {
    return {
      service_list: [],
      error: "",
      search_query: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.date || !v.meta.number_of_hours || !v.meta.description;
    },
    filtered_services() {
      let v = this;
      if (!v.search_query) {
        return v.service_list;
      }
      return v.service_list.filter((service) =>
        service.description.toLowerCase().includes(v.search_query.toLowerCase())
      );
    },
  },
  methods: {
    format_date,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(timebag) {
      let v = this;
      v.service_list = timebag.timebag_services || [];
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.error = "";
      // v.uuid = "";
    },
    edit_service(uuid) {
      let v = this;
      v.$emit("edit_service", uuid);
      v.close_modal();
    },
    delete_service(uuid) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete service?"),
        v,
        () => {
          del("/timebag/service", { uuid: uuid })
            .then(() => {
              v.service_list = v.service_list.filter(
                (service) => service.uuid !== uuid
              );
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
